import { Injectable, inject } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { LocationsTranslationCountersHttpClient } from './locations-translation-counters.http-client';
import { LocationTranslationCountersActions } from './locations-translation-counters.store';

@Injectable({ providedIn: 'root' })
export class LocationsTranslationCountersEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(LocationsTranslationCountersHttpClient);

  public effects = createEffectFactory(LocationTranslationCountersActions, this.actions$);

  public fetch$ = this.effects(LocationTranslationCountersActions.fetchCollection, ({ payload }) =>
    this.http.fetch(payload.scope).pipe(map(data => ({ data, scope: payload.scope }))),
  );
}
